import React from 'react'

import BkFlowRoomCardAdaDescription from '../../elements/accessiblity/BkFlowRoomCardAdaDescription'
import BkFlowFeaturedIcons from '../../elements/icons/BkFlowRoomFeaturedIcons'
import BkFlowRoomDetailsIcons from '../../elements/icons/BkFlowRoomDetailsIcons'
import BkFlowRoomDetailsCta from '../elements/BkFlowRoomDetailsCta'

import galleryIcon from '../../../../assets/icons/gallery.png'
import tourIcon from '../../../../assets/icons/tour.png'
import floorPlanIcon from '../../../../assets/icons/floorplan.png'
import mapIcon from '../../../../assets/icons/map.png'

import yn from 'yn'
import _ from 'lodash'
import renderHtml from 'react-render-html'

const BkFlowRoomDetailsDefault = props => {
	const {
		combineIcons,
		fullScreenEvent,
		hotelLabels,
		renderRoomDescription,
		renderRoomLongDescription,
		roomData,
		roomFloorPlanSrc,
		roomGroup,
		roomMapUrlSrc,
		virtualTourEvent,
		virtualTourSrc,
	} = props

	return (
		<div className="bk-flow-room__details-content room-details-default">
			{(
				yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_GALLERY_TOGGLE) ||
				virtualTourSrc ||
				roomFloorPlanSrc ||
				roomMapUrlSrc
			) &&
				<div className="bk-flow-room__details-buttons row middle-xs center-xs">
					{ yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_GALLERY_TOGGLE) &&
						<button
							className="btn btn-transparent btn-xl row col-xs-12 col-md-6 col-lg middle-xs center-xs"
							onClick={ () => fullScreenEvent() }
						>
							<img
								className="bk-flow-room__details-buttons-icon"
								src={ galleryIcon }
								alt="Room Details Gallery"
							/>
							<span>{ hotelLabels.photoGallery ? hotelLabels.photoGallery : 'Photo Gallery' }</span>
						</button>
					}

					{ virtualTourSrc &&
						<button
							className="btn btn-transparent btn-xl row col-xs-12 col-md-6 col-lg middle-xs center-xs"
							onClick={virtualTourEvent}
						>
							<img
								className="bk-flow-room__details-buttons-icon"
								src={ tourIcon }
								alt="Room Details 360 Tour"
							/>
							<span>{ hotelLabels.virtualTour ? hotelLabels.virtualTour : 'Virtual Tour' }</span>
						</button>
					}

					{process.env.REACT_APP_COMPONENT_ROOM_DETAILS_FLOORPLAN_COMPONENT === 'default' &&
					 roomFloorPlanSrc &&
						<button
							className="btn btn-transparent btn-xl row col-xs-12 col-md-6 col-lg middle-xs center-xs"
							onClick={ () => window.open(roomFloorPlanSrc, 'Floor plan', 'height=600,width=450') }
						>
							<img
								className="bk-flow-room__details-buttons-icon"
								src={ floorPlanIcon }
								alt="Room Details Floor Plan"
							/>
							<span>{ hotelLabels.floorPlan ? hotelLabels.floorPlan : 'Floor Plan' }</span>
						</button>
					}

					{ roomMapUrlSrc &&
						<button
							className="btn btn-transparent btn-xl row col-xs-12 col-md-6 col-lg middle-xs center-xs"
							onClick={ () => window.open(roomMapUrlSrc, 'Map URL') }
						>
							<img
								className="bk-flow-room__details-buttons-icon"
								src={ mapIcon }
								alt="Room Details Floor Plan"
							/>
							<span>{ hotelLabels.map ? hotelLabels.map : 'Map' }</span>
						</button>
					}
				</div>
			}

			{(hotelLabels.roomDetailsHeading || hotelLabels.roomDetailsSubheading) &&
				<div className="bk-flow-room__details-heading">
					{ hotelLabels.roomDetailsHeading && <h5 className="u-txt-center">{ hotelLabels.roomDetailsHeading }</h5> }
					{ hotelLabels.roomDetailsSubheading && <p className="u-txt-center">{ hotelLabels.roomDetailsSubheading }</p> }
				</div>
			}

			{ !_.isEmpty(renderRoomLongDescription) ?
				<div className="description">{renderHtml(renderRoomLongDescription)}</div>
			: !_.isEmpty(renderRoomDescription) ?
				renderRoomDescription
			: null}

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION_ACCESSIBILITY_DESCRIPTION) &&
				roomData.viewExtensions &&
				roomData.viewExtensions.adaDetails &&
					<BkFlowRoomCardAdaDescription
						adaDisclaimer={ roomData.viewExtensions.adaDetails }
					/>
			}

			{ !combineIcons &&
				yn(process.env.REACT_APP_COMPONENT_ROOM_FEATURED_ICONS) &&
				yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ICONS) &&
				<div className="bk-flow-room__featured-icons-mobile">
					<BkFlowFeaturedIcons
						roomGroup={ roomGroup }
						roomData={ roomData }
					/>
				</div>
			}

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ICONS) &&
				<BkFlowRoomDetailsIcons
					displayAllIcons={combineIcons}
					roomGroup={ roomGroup }
					roomData={ roomData }
				/>
			}

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_AMENITY_CTAS) &&
				<BkFlowRoomDetailsCta
					roomGroup={ roomGroup }
					roomType={ roomData }
				/>
			}

			{ process.env.REACT_APP_COMPONENT_ROOM_DETAILS_FLOORPLAN_COMPONENT === 'image' &&
				<div className="bk-flow-room__floor-plan-diagram">
					<img src={roomFloorPlanSrc} alt="Room Floor Plan" />
				</div>
			}
		</div>
	)
}

export default BkFlowRoomDetailsDefault


// WEBPACK FOOTER //
// ./src/components/room/room-details/layouts/BkFlowRoomDetailsDefault.js